import { useMatomo } from '@datapunt/matomo-tracker-react';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { setLocalStorageItem, getLocalStorageItem } from '../utils/clientStorage';

const Tracker = () => {
  const location = useLocation();
  const { trackPageView, pushInstruction } = useMatomo();
  useEffect(() => {
    if (location.search.includes('relyingParty') || location.pathname.indexOf('/c/') > -1) {
      return;
    }
    const NewVisitID = getLocalStorageItem('NewVisitID');
    const visitID = getLocalStorageItem('visitID');
    if (
      typeof visitID !== 'undefined' &&
      (typeof visitID === 'undefined' || (typeof visitID !== 'undefined' && visitID !== NewVisitID))
    ) {
      pushInstruction('appendToTrackingUrl', 'send_image=0&new_visit=1');
    } else {
      pushInstruction('appendToTrackingUrl', 'send_image=0');
    }

    trackPageView();
    if (
      typeof visitID !== 'undefined' &&
      (typeof visitID === 'undefined' || (typeof visitID !== 'undefined' && visitID !== NewVisitID))
    )
      setLocalStorageItem('visitID', NewVisitID);
  }, [location.pathname, location.search, trackPageView, pushInstruction]);
  return null;
};
export default Tracker;
